import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "tailwindcss/tailwind.css"
import "animate.css"

import axios from "axios";

axios.defaults.baseURL = "https://rcv-shopee-backend.herokuapp.com/";

createApp(App).use(store).use(router).mount('#app')
